import { toString, Record } from "./fable_modules/fable-library.3.7.20/Types.js";
import { option_type, int32_type, bool_type, record_type, lambda_type, unit_type, list_type, string_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { MenuItem$reflection, SubItem$reflection, Role$reflection, RoleItem$reflection, AvailableLanguage$reflection } from "./CommonTypes.js";
import { FunctionComponent_Of_Z5A158BBF } from "./fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "./Redux/Store.js";
import { getTranslationFrom } from "./Global.js";
import * as react from "react";
import { effect } from "./Components/Hooks/ClickOutside.js";
import { tryLast, tryHead, map } from "./fable_modules/fable-library.3.7.20/Array.js";
import { printf, toText, split, substring } from "./fable_modules/fable-library.3.7.20/String.js";
import { Size, SveaIcon, renderSveaIconBySize } from "./ViewUtils.js";
import { DOMAttr, Prop, HTMLAttr } from "./fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library.3.7.20/Seq.js";
import { splitAt, reverse, tail, sum, length, isEmpty, item as item_2, mapIndexed, zip, filter, ofArray, map as map_1 } from "./fable_modules/fable-library.3.7.20/List.js";
import { createThrottle, optToStr, classNames } from "./Utils.js";
import { keyValueList } from "./fable_modules/fable-library.3.7.20/MapUtil.js";
import { Helpers_equalsButFunctions } from "./fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { uncurry, equals, max, comparePrimitives, min, int32ToString } from "./fable_modules/fable-library.3.7.20/Util.js";
import { FSharpMap__get_Count, ofList } from "./fable_modules/fable-library.3.7.20/Map.js";
import { attachDisposableEvent } from "./Components/Hooks/Common.js";
import { value as value_4, map as map_2, defaultArg } from "./fable_modules/fable-library.3.7.20/Option.js";
import { Browser_Types_Event__Event_get_Value } from "./fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { baseUrl } from "./HttpV2.js";

export class CurrentUserProps extends Record {
    constructor(AccountType, SelectedLanguage, Username, AvailableLanguages, SelectLanguageFn) {
        super();
        this.AccountType = AccountType;
        this.SelectedLanguage = SelectedLanguage;
        this.Username = Username;
        this.AvailableLanguages = AvailableLanguages;
        this.SelectLanguageFn = SelectLanguageFn;
    }
}

export function CurrentUserProps$reflection() {
    return record_type("App.Navbar.CurrentUserProps", [], CurrentUserProps, () => [["AccountType", string_type], ["SelectedLanguage", string_type], ["Username", string_type], ["AvailableLanguages", list_type(AvailableLanguage$reflection())], ["SelectLanguageFn", lambda_type(string_type, unit_type)]]);
}

const renderCurrentUser = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_9, children_7, children_5, fullname, matchValue, letters, matchValue_2, matchValue_3, matchValue_1, children_40, children_13, props_39, children_38;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const isOpenState = react.useState(false);
    const containerRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(containerRef, () => {
        isOpenState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    const maybeShow = (isOpenState[0]) ? " show" : "";
    const children_42 = [(children_9 = [(children_7 = [(children_5 = [(fullname = props.Username, (matchValue = (fullname.indexOf(" ") >= 0), matchValue ? ((letters = map((word) => {
        if (word.length > 0) {
            return substring(word, 0, 1);
        }
        else {
            return "";
        }
    }, split(fullname, [])), ((matchValue_2 = tryHead(letters), (matchValue_2 == null) ? "" : matchValue_2)) + ((matchValue_3 = tryLast(letters), (matchValue_3 == null) ? "" : matchValue_3)))) : ((matchValue_1 = (fullname.length | 0), (matchValue_1 === 0) ? "" : ((matchValue_1 === 1) ? substring(fullname, 0, 1) : substring(fullname, 0, 2))))))], react.createElement("span", {
        className: "user__avatar-initials",
    }, ...children_5))], react.createElement("div", {
        className: "user__avatar-circle",
    }, ...children_7))], react.createElement("div", {
        ["data-regression"]: "user-initials",
    }, ...children_9)), (children_40 = [(children_13 = [react.createElement("span", {}, props.Username), renderSveaIconBySize(new SveaIcon(13), new Size(0))], react.createElement("a", {
        className: "nav-link pointer",
        ["data-regression"]: "user-name",
        onClick: (_arg_1) => {
            isOpenState[1](!(isOpenState[0]));
        },
    }, ...children_13)), (props_39 = [new HTMLAttr(65, "dropdown-menu user-menu" + maybeShow)], (children_38 = toList(delay(() => {
        let children_21, children_19, children_15, children_17, selectedLanguage;
        return append(singleton((children_21 = [(children_19 = [(children_15 = [getTranslation("Common.Language")], react.createElement("span", {
            className: "user__heading",
        }, ...children_15)), (children_17 = map_1((selectedLanguage = props.SelectedLanguage, (availableLanguage) => {
            const languageCssClasses = classNames(ofArray([["user__language-choice", true], ["user__language-choice--selected", selectedLanguage === availableLanguage.Language]]));
            const children_3 = toList(delay(() => append(singleton(react.createElement("span", {}, availableLanguage.LanguageLong)), delay(() => ((selectedLanguage === availableLanguage.Language) ? singleton(renderSveaIconBySize(new SveaIcon(12), new Size(0))) : singleton(react.createElement(react.Fragment, {})))))));
            return react.createElement("div", {
                className: languageCssClasses,
                onClick: (_arg) => {
                    props.SelectLanguageFn(availableLanguage.Language);
                    isOpenState[1](false);
                },
            }, ...children_3);
        }), props.AvailableLanguages), react.createElement("div", {
            className: "user__languages",
        }, ...children_17))], react.createElement("div", {
            className: "d-flex flex-column align-items-left w-100",
        }, ...children_19))], react.createElement("div", {}, ...children_21))), delay(() => {
            let children_25, children_23;
            return append((props.AccountType === "S") ? singleton((children_25 = [(children_23 = [getTranslation("CustomerContract.ChangePassword")], react.createElement("a", {
                className: "user__link",
                href: "#/ChangePassword/",
                id: "change-password-link",
                ["data-regression"]: "changePasswordLink",
            }, ...children_23))], react.createElement("div", {
                className: "dropdown-item",
            }, ...children_25))) : singleton(react.createElement(react.Fragment, {})), delay(() => {
                let children_30, children_28;
                return append(singleton((children_30 = [(children_28 = [getTranslation("CustomerContract.LinkAccount")], react.createElement("a", {
                    className: "user__link",
                    href: "#/LinkAccount/",
                }, ...children_28))], react.createElement("div", {
                    className: "dropdown-item",
                }, ...children_30))), delay(() => {
                    let children_36, children_34, children_32;
                    return singleton((children_36 = [(children_34 = [(children_32 = [getTranslation("CustomerContract.Logout")], react.createElement("span", {
                        ["data-regression"]: "logoutLink",
                    }, ...children_32))], react.createElement("div", {
                        className: "dropdown-item dropdown-item--logout",
                        id: "logout-link",
                    }, ...children_34))], react.createElement("a", {
                        href: "./Logout",
                    }, ...children_36)));
                }));
            }));
        }));
    })), react.createElement("div", keyValueList(props_39, 1), ...children_38)))], react.createElement("div", {
        className: "dropdown",
    }, ...children_40))];
    return react.createElement("div", {
        className: "user",
        ref: containerRef,
    }, ...children_42);
}, "CurrentUser", Helpers_equalsButFunctions, void 0, "renderCurrentUser", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Navbar.fs", 142);

export class PickerProps extends Record {
    constructor(RoleItems, LoadSelectedRoleFn) {
        super();
        this.RoleItems = RoleItems;
        this.LoadSelectedRoleFn = LoadSelectedRoleFn;
    }
}

export function PickerProps$reflection() {
    return record_type("App.Navbar.PickerProps", [], PickerProps, () => [["RoleItems", RoleItem$reflection()], ["LoadSelectedRoleFn", lambda_type(Role$reflection(), unit_type)]]);
}

export class PickerState extends Record {
    constructor(ShowDropDown, UgIndex, UgFilter) {
        super();
        this.ShowDropDown = ShowDropDown;
        this.UgIndex = UgIndex;
        this.UgFilter = UgFilter;
    }
}

export function PickerState$reflection() {
    return record_type("App.Navbar.PickerState", [], PickerState, () => [["ShowDropDown", bool_type], ["UgIndex", option_type(int32_type)], ["UgFilter", string_type]]);
}

const renderUgPicker = FunctionComponent_Of_Z5A158BBF((props) => {
    let props_3, props_7, children_4, props_9;
    const state = react.useState(new PickerState(false, void 0, ""));
    let filteredRoleItems;
    const filterTerm = (state[0]).UgFilter;
    const selectableRoles = props.RoleItems.SelectableRoles;
    filteredRoleItems = map_1((tuple) => tuple[0], filter((tupledArg) => (tupledArg[1].indexOf(filterTerm.toLocaleLowerCase()) >= 0), zip(selectableRoles, map_1((role) => {
        let clientNr;
        const matchValue = role.ClientNr;
        clientNr = ((matchValue == null) ? "" : int32ToString(matchValue));
        let invoiceeNr;
        const matchValue_1 = role.InvoiceeNr;
        invoiceeNr = ((matchValue_1 == null) ? "" : int32ToString(matchValue_1));
        let arg;
        const s = optToStr(role.RoleName);
        arg = s.toLocaleLowerCase();
        return toText(printf("%s__%s__%s"))(arg)(clientNr)(invoiceeNr);
    }, selectableRoles))));
    const dropDownRef = react.useRef(void 0);
    const ugSearchInputRef = react.useRef(void 0);
    const currentSelectedUg = react.useRef(void 0);
    const ugChoiceRoles = ofList(mapIndexed((index, role_1) => [index, role_1], filteredRoleItems));
    react.useEffect(() => {
        const disp = (() => effect(dropDownRef, () => {
        let inputRecord;
        state[1]((inputRecord = (state[0]), new PickerState(false, void 0, "")));
    }, void 0))();
        return () => disp.Dispose();
    });
    react.useEffect(() => {
        if ((state[0]).ShowDropDown) {
            const matchValue_3 = ugSearchInputRef.current;
            if (matchValue_3 != null) {
                const value = matchValue_3;
                value.focus();
            }
        }
    }, [(state[0]).ShowDropDown]);
    react.useEffect(() => {
        const matchValue_4 = (state[0]).UgIndex;
        if (matchValue_4 == null) {
        }
        else {
            const matchValue_5 = currentSelectedUg.current;
            if (matchValue_5 != null) {
                const value_1 = matchValue_5;
                value_1.scrollIntoView(false);
            }
        }
    }, [(state[0]).UgIndex]);
    const onUgChoiceClick = (role_2) => {
        let inputRecord_1;
        state[1]((inputRecord_1 = (state[0]), new PickerState(false, inputRecord_1.UgIndex, inputRecord_1.UgFilter)));
        props.LoadSelectedRoleFn(role_2);
    };
    react.useEffect(() => {
        const disp = (() => attachDisposableEvent((e) => {
        let inputRecord_2, e_2, inputRecord_3, inputRecord_4;
        const matchValue_6 = e.key;
        switch (matchValue_6) {
            case "Escape": {
                state[1]((inputRecord_2 = (state[0]), new PickerState(false, inputRecord_2.UgIndex, inputRecord_2.UgFilter)));
                break;
            }
            case "ArrowDown": {
                const newIndex = (e_2 = (defaultArg(map_2((index_1) => (index_1 + 1), (state[0]).UgIndex), 0) | 0), min(comparePrimitives, FSharpMap__get_Count(ugChoiceRoles) - 1, e_2));
                state[1]((inputRecord_3 = (state[0]), new PickerState(inputRecord_3.ShowDropDown, newIndex, inputRecord_3.UgFilter)));
                break;
            }
            case "ArrowUp": {
                const newIndex_1 = max(comparePrimitives, 0, defaultArg(map_2((index_2) => (index_2 - 1), (state[0]).UgIndex), 0));
                state[1]((inputRecord_4 = (state[0]), new PickerState(inputRecord_4.ShowDropDown, newIndex_1, inputRecord_4.UgFilter)));
                break;
            }
            case "Enter": {
                const matchValue_7 = (state[0]).UgIndex;
                if (matchValue_7 == null) {
                }
                else {
                    onUgChoiceClick(item_2(matchValue_7, filteredRoleItems));
                }
                break;
            }
            default: {
            }
        }
    }, value_4(dropDownRef.current), "keydown"))();
        return () => disp.Dispose();
    });
    const maybeShowDropdownClass = (state[0]).ShowDropDown ? " show" : "";
    const ugChoicesHtml = mapIndexed((index_4, role_3) => {
        let arg_8;
        let clientNr_2;
        const matchValue_8 = role_3.ClientNr;
        clientNr_2 = ((matchValue_8 == null) ? "" : int32ToString(matchValue_8));
        let invoiceeNr_2;
        const matchValue_9 = role_3.InvoiceeNr;
        invoiceeNr_2 = ((matchValue_9 == null) ? "" : (": " + int32ToString(matchValue_9)));
        let id;
        const matchValue_10 = role_3.InvoiceeNr;
        if (matchValue_10 == null) {
            id = toText(printf("ug-choice-%s"))(clientNr_2);
        }
        else {
            const arg_6 = int32ToString(matchValue_10);
            id = toText(printf("ug-choice-%s:%s"))(clientNr_2)(arg_6);
        }
        const classes = classNames(ofArray([["ug__dropdown-choice", true], ["ug__dropdown-choice--active", equals(index_4, (state[0]).UgIndex)]]));
        const refValue = equals(index_4, (state[0]).UgIndex) ? currentSelectedUg : (void 0);
        const props_1 = toList(delay(() => append(singleton(new HTMLAttr(65, classes)), delay(() => append(singleton(new HTMLAttr(99, id)), delay(() => append((refValue != null) ? singleton(new Prop(3, value_4(refValue))) : empty(), delay(() => singleton(new DOMAttr(40, (_arg_2) => {
            onUgChoiceClick(role_3);
        }))))))))));
        const children = [(arg_8 = optToStr(role_3.RoleName), toText(printf("%s (%s%s)"))(arg_8)(clientNr_2)(invoiceeNr_2))];
        return react.createElement("li", keyValueList(props_1, 1), ...children);
    }, filteredRoleItems);
    let ugName;
    const arg_12 = toString(props.RoleItems.SelectedRole.ClientNr);
    const arg_11 = optToStr(props.RoleItems.SelectedRole.RoleName);
    ugName = toText(printf("%s (%s)"))(arg_11)(arg_12);
    const children_8 = [(props_3 = [new HTMLAttr(65, "ug__search" + ((state[0]).ShowDropDown ? "" : " ug__search--hide")), new HTMLAttr(54, "off"), new HTMLAttr(99, "ug-search-input"), new Prop(3, ugSearchInputRef), new HTMLAttr(159, "text"), new HTMLAttr(161, (state[0]).UgFilter), new DOMAttr(9, (e_5) => {
        let inputRecord_5;
        state[1]((inputRecord_5 = (state[0]), new PickerState(inputRecord_5.ShowDropDown, inputRecord_5.UgIndex, Browser_Types_Event__Event_get_Value(e_5))));
    })], react.createElement("input", keyValueList(props_3, 1))), (props_7 = [new HTMLAttr(65, "ug-name-container" + ((state[0]).ShowDropDown ? " d-none" : "")), new DOMAttr(40, (_arg_5) => {
        let inputRecord_6;
        state[1]((inputRecord_6 = (state[0]), new PickerState(!(state[0]).ShowDropDown, inputRecord_6.UgIndex, inputRecord_6.UgFilter)));
    })], (children_4 = [react.createElement("span", {}, ugName), renderSveaIconBySize(new SveaIcon(13), new Size(0))], react.createElement("div", keyValueList(props_7, 1), ...children_4))), (props_9 = [new HTMLAttr(65, "dropdown-menu ug__dropdown" + maybeShowDropdownClass)], react.createElement("ul", keyValueList(props_9, 1), ...ugChoicesHtml))];
    return react.createElement("div", {
        className: "ug nav-link dropdown",
        ref: dropDownRef,
    }, ...children_8);
}, "UGPicker", Helpers_equalsButFunctions, void 0, "renderUgPicker", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Navbar.fs", 326);

class DropDownItemProps extends Record {
    constructor(SubItem, CloseMenuFn) {
        super();
        this.SubItem = SubItem;
        this.CloseMenuFn = CloseMenuFn;
    }
}

function DropDownItemProps$reflection() {
    return record_type("App.Navbar.DropDownItemProps", [], DropDownItemProps, () => [["SubItem", SubItem$reflection()], ["CloseMenuFn", lambda_type(unit_type, unit_type)]]);
}

function renderDropDownItem() {
    return FunctionComponent_Of_Z5A158BBF((props) => {
        const sideMenuOpenState = react.useState(false);
        const sideMenuRef = react.useRef(void 0);
        const closeAllMenus = () => {
            sideMenuOpenState[1](false);
            props.CloseMenuFn();
        };
        react.useEffect(() => {
        const disp = (() => effect(sideMenuRef, () => {
            sideMenuOpenState[1](false);
        }, void 0))();
        return () => disp.Dispose();
    });
        const renderAnchor = (isExternalUrl, menuItem) => {
            let props_7;
            const hasSideMenu = !isEmpty(menuItem.SubItems);
            let sideMenuContainerHtml;
            const matchValue = sideMenuOpenState[0];
            if (matchValue) {
                const sideMenuItems = map_1((item) => renderDropDownItem()(new DropDownItemProps(item, closeAllMenus)), menuItem.SubItems);
                const dropdownClasses = classNames(ofArray([["dropdown-menu", true], ["show", true], ["dropdown-menu--side", true]]));
                sideMenuContainerHtml = react.createElement("div", {
                    className: dropdownClasses,
                    ref: sideMenuRef,
                }, ...sideMenuItems);
            }
            else {
                sideMenuContainerHtml = react.createElement(react.Fragment, {});
            }
            let rightArrowHtml;
            if (hasSideMenu) {
                const ballContainerClasses = classNames(ofArray([["dropdown-item__right", true], ["d-flex", true], ["justify-content-end", true]]));
                const children_4 = [renderSveaIconBySize(new SveaIcon(14), new Size(1))];
                rightArrowHtml = react.createElement("div", {
                    className: ballContainerClasses,
                }, ...children_4);
            }
            else {
                rightArrowHtml = react.createElement(react.Fragment, {});
            }
            const classes = classNames(ofArray([["dropdown-item", true], ["d-flex", hasSideMenu], ["justify-content-between", hasSideMenu], ["align-items-center", hasSideMenu]]));
            if (hasSideMenu) {
                const props_9 = toList(delay(() => append(singleton(new DOMAttr(52, (_arg_1) => {
                    sideMenuOpenState[1](true);
                })), delay(() => append(singleton(new DOMAttr(53, (_arg_2) => {
                    sideMenuOpenState[1](false);
                })), delay(() => append(singleton(new HTMLAttr(65, classes)), delay(() => (isExternalUrl ? singleton(new HTMLAttr(157, "_blank")) : empty())))))))));
                const children_8 = [(props_7 = toList(delay(() => append(singleton(new HTMLAttr(65, "dropdown-item__left")), delay(() => append(singleton(new HTMLAttr(94, defaultArg(menuItem.Url, ""))), delay(() => append(singleton(new DOMAttr(40, (_arg_3) => {
                    closeAllMenus();
                })), delay(() => (isExternalUrl ? singleton(new HTMLAttr(157, "_blank")) : empty()))))))))), react.createElement("a", keyValueList(props_7, 1), menuItem.Title)), rightArrowHtml, sideMenuContainerHtml];
                return react.createElement("div", keyValueList(props_9, 1), ...children_8);
            }
            else {
                const props_11 = toList(delay(() => append(singleton(new HTMLAttr(65, "dropdown-item")), delay(() => append(singleton(new HTMLAttr(94, defaultArg(menuItem.Url, ""))), delay(() => append(isExternalUrl ? singleton(new HTMLAttr(157, "_blank")) : empty(), delay(() => singleton(new DOMAttr(40, (_arg_4) => {
                    closeAllMenus();
                }))))))))));
                return react.createElement("a", keyValueList(props_11, 1), menuItem.Title);
            }
        };
        const matchValue_1 = props.SubItem;
        let pattern_matching_result, menuItem_1;
        switch (matchValue_1.tag) {
            case 1: {
                pattern_matching_result = 0;
                menuItem_1 = matchValue_1.fields[0];
                break;
            }
            case 2: {
                pattern_matching_result = 1;
                break;
            }
            default: {
                pattern_matching_result = 0;
                menuItem_1 = matchValue_1.fields[0];
            }
        }
        switch (pattern_matching_result) {
            case 0: {
                return renderAnchor(false, menuItem_1);
            }
            case 1: {
                return renderAnchor(true, matchValue_1.fields[0]);
            }
        }
    }, void 0, uncurry(2, void 0), void 0, "renderDropDownItem", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Navbar.fs", 416);
}

class MenuItemProps extends Record {
    constructor(IsHamburger, Item) {
        super();
        this.IsHamburger = IsHamburger;
        this.Item = Item;
    }
}

function MenuItemProps$reflection() {
    return record_type("App.Navbar.MenuItemProps", [], MenuItemProps, () => [["IsHamburger", bool_type], ["Item", MenuItem$reflection()]]);
}

const renderMenuItem = FunctionComponent_Of_Z5A158BBF((props) => {
    let props_1, children_6, children_8;
    const isOpenState = react.useState(false);
    const navbarRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(navbarRef, () => {
        isOpenState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    react.useEffect(() => {
        const disp = (() => {
        const eventType = "blur";
        const handleEvent = (_arg) => {
            if (equals(document.activeElement, document.querySelector("iframe"))) {
                isOpenState[1](false);
            }
        };
        window.focus();
        window.addEventListener(eventType, handleEvent);
        return {
            Dispose() {
                window.removeEventListener(eventType, handleEvent);
            },
        };
    })();
        return () => disp.Dispose();
    });
    if (isEmpty(props.Item.SubItems)) {
        const navbarItemClasses = classNames(ofArray([["navbar-item", true], ["navbar-item--hamburger", props.IsHamburger]]));
        const children_2 = [(props_1 = [new HTMLAttr(65, "navbar-item__link"), new HTMLAttr(94, defaultArg(props.Item.Url, ""))], react.createElement("a", keyValueList(props_1, 1), props.Item.Title))];
        return react.createElement("li", {
            className: navbarItemClasses,
            ref: navbarRef,
        }, ...children_2);
    }
    else {
        const dropDownMenuClasses = classNames(ofArray([["dropdown-menu", true], ["dropdown-menu--hamburger", props.IsHamburger], ["show", isOpenState[0]]]));
        const navbarItemClasses_1 = classNames(ofArray([["navbar-item", true], ["navbar-item--hamburger", props.IsHamburger], ["dropdown", true]]));
        const children_10 = [(children_6 = [react.createElement("span", {}, props.Item.Title), renderSveaIconBySize(new SveaIcon(13), new Size(0))], react.createElement("a", {
            className: "navbar-item__link",
            onClick: (_arg_1) => {
                isOpenState[1]((value_1) => (!value_1));
            },
        }, ...children_6)), (children_8 = map_1((subItem) => renderDropDownItem()(new DropDownItemProps(subItem, () => {
            isOpenState[1](false);
        })), props.Item.SubItems), react.createElement("div", {
            className: dropDownMenuClasses,
        }, ...children_8))];
        return react.createElement("li", {
            className: navbarItemClasses_1,
            ref: navbarRef,
        }, ...children_10);
    }
}, "MenuItem", Helpers_equalsButFunctions, void 0, "renderMenuItem", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Navbar.fs", 485);

function getNrOfHorizontalMenuItems(menuItems, windowWidth) {
    if (document.getElementById("menu-container__right") == null) {
        return length(menuItems) | 0;
    }
    else {
        const getNumberOfItemsToPutInNormalMenu = (availabelWidth_mut, reversedLeftMenuItemWidths_mut) => {
            getNumberOfItemsToPutInNormalMenu:
            while (true) {
                const availabelWidth = availabelWidth_mut, reversedLeftMenuItemWidths = reversedLeftMenuItemWidths_mut;
                if (sum(reversedLeftMenuItemWidths, {
                    GetZero: () => 0,
                    Add: (x, y) => (x + y),
                }) < availabelWidth) {
                    return length(reversedLeftMenuItemWidths) | 0;
                }
                else if (length(reversedLeftMenuItemWidths) === 1) {
                    return 0;
                }
                else {
                    availabelWidth_mut = availabelWidth;
                    reversedLeftMenuItemWidths_mut = tail(reversedLeftMenuItemWidths);
                    continue getNumberOfItemsToPutInNormalMenu;
                }
                break;
            }
        };
        return getNumberOfItemsToPutInNormalMenu(((windowWidth - document.getElementById("navbar-container__logo-container").clientWidth) - document.getElementById("menu-container__right").clientWidth) + 50, reverse(map_1((item) => (item.Title.length * 13), menuItems))) | 0;
    }
}

export class MenuProps extends Record {
    constructor(MenuItems) {
        super();
        this.MenuItems = MenuItems;
    }
}

export function MenuProps$reflection() {
    return record_type("App.Navbar.MenuProps", [], MenuProps, () => [["MenuItems", list_type(MenuItem$reflection())]]);
}

const renderMenu = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_3, children_5;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const windowWidthState = react.useState(window.innerWidth);
    const patternInput = splitAt(getNrOfHorizontalMenuItems(props.MenuItems, windowWidthState[0]), props.MenuItems);
    const hamburgerMenuItems = patternInput[1];
    const hamburgerOpenState = react.useState(false);
    const containerRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(containerRef, () => {
        hamburgerOpenState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    const throttle250ms = createThrottle(250);
    react.useEffect(() => {
        const disp = (() => {
        const eventType = "resize";
        const handleEvent = (_arg) => {
            throttle250ms(() => {
                windowWidthState[1](window.innerWidth);
            });
        };
        window.addEventListener(eventType, handleEvent);
        return {
            Dispose() {
                window.removeEventListener(eventType, handleEvent);
            },
        };
    })();
        return () => disp.Dispose();
    });
    react.useEffect(() => {
        const disp = (() => {
        const eventType_1 = "blur";
        const handleEvent_1 = (_arg_1) => {
            if (equals(document.activeElement, document.querySelector("iframe"))) {
                hamburgerOpenState[1](false);
            }
        };
        window.focus();
        window.addEventListener(eventType_1, handleEvent_1);
        return {
            Dispose() {
                window.removeEventListener(eventType_1, handleEvent_1);
            },
        };
    })();
        return () => disp.Dispose();
    });
    let plainlyRenderedMenuItemsHtml;
    const children = map_1((item) => renderMenuItem(new MenuItemProps(false, item)), patternInput[0]);
    plainlyRenderedMenuItemsHtml = react.createElement("ul", {
        className: "navbar-items",
    }, ...children);
    let hamburgerMenuItemsHtml;
    if (isEmpty(hamburgerMenuItems)) {
        hamburgerMenuItemsHtml = react.createElement(react.Fragment, {});
    }
    else {
        const hamburgerClasses = classNames(ofArray([["navbar-items", true], ["navbar-items--hamburger", true], ["navbar-items--hidden", !(hamburgerOpenState[0])]]));
        const children_7 = [(children_3 = [getTranslationFrom(translationsLoadState, "Menu")], react.createElement("div", {
            className: "hamburger-button",
            onClick: (_arg_2) => {
                hamburgerOpenState[1](!(hamburgerOpenState[0]));
            },
        }, ...children_3)), (children_5 = map_1((item_1) => renderMenuItem(new MenuItemProps(true, item_1)), hamburgerMenuItems), react.createElement("ul", {
            className: hamburgerClasses,
        }, ...children_5))];
        hamburgerMenuItemsHtml = react.createElement("div", {
            className: "hamburger-container",
        }, ...children_7);
    }
    return react.createElement("div", {
        className: "menu-container__left",
        ref: containerRef,
    }, plainlyRenderedMenuItemsHtml, hamburgerMenuItemsHtml);
}, "Menu", Helpers_equalsButFunctions, void 0, "renderMenu", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Navbar.fs", 608);

export function renderNavbar(loadSelectedRoleFn, loadSelectLanguageFn, context) {
    let children_2, children, props, children_6, children_4;
    const menuHtml = renderMenu(new MenuProps(context.MenuItems));
    const children_8 = [(children_2 = [(children = [(props = [new HTMLAttr(149, baseUrl + "img/svealogo.png"), new HTMLAttr(8, "svea logo"), new HTMLAttr(163, 100), new HTMLAttr(91, 37), new HTMLAttr(65, "svea-logo")], react.createElement("img", keyValueList(props, 1)))], react.createElement("a", {
        href: baseUrl,
        className: "navbar-brand",
    }, ...children))], react.createElement("div", {
        id: "navbar-container__logo-container",
        className: "navbar-container__logo-container",
    }, ...children_2)), (children_6 = [menuHtml, (children_4 = [renderUgPicker(new PickerProps(context.RoleItems, loadSelectedRoleFn)), renderCurrentUser(new CurrentUserProps(context.AccountType, context.SelectedLanguage, context.CurrentUserName, context.AvailableLanguages, loadSelectLanguageFn))], react.createElement("div", {
        id: "menu-container__right",
        className: "menu-container__right",
    }, ...children_4))], react.createElement("div", {
        className: "navbar-container__menu-container",
    }, ...children_6))];
    return react.createElement("nav", {
        className: "navbar-container",
    }, ...children_8);
}

